import { Global } from "./Global"

class NativeCbk {
    pickImageFromAlbumCallback: Function = null
    saveImageToAlbumCallback: Function = null
    
    /**
     * 选择照片的回调函数
     * @param filePath 文件路径
     */
    onPickImageFromAlbum (filePath: string) {
        if (this.pickImageFromAlbumCallback) {
            this.pickImageFromAlbumCallback(filePath)
            this.pickImageFromAlbumCallback = null
        }
    }

    onSaveImageToAlbum (success: boolean) {
        if (this.saveImageToAlbumCallback) {
            this.saveImageToAlbumCallback(success)
            this.saveImageToAlbumCallback = null
        }
    }

    /**
     * 设备屏幕方向改变的回调函数
     * @param orientation 设备方向 H横屏 V竖屏
     */
    onOrientationChanged (orientation: string) {
        // 根据屏幕方向重新设置设计分辨率、视图框架大小和当前画布大小
        let frameSize = cc.view.getFrameSize()
        let designResolution = cc.view.getDesignResolutionSize()

        if (orientation === "H") {
            cc.view.setOrientation(cc.macro.ORIENTATION_LANDSCAPE)
            cc.view.setDesignResolutionSize(Math.max(designResolution.width, designResolution.height), Math.min(designResolution.width, designResolution.height), cc.view.getResolutionPolicy())
            cc.view.setFrameSize(Math.max(frameSize.width, frameSize.height), Math.min(frameSize.width, frameSize.height))
        }else if (orientation === "V") {
            cc.view.setOrientation(cc.macro.ORIENTATION_PORTRAIT)
            cc.view.setDesignResolutionSize(Math.min(designResolution.width, designResolution.height), Math.max(designResolution.width, designResolution.height), cc.view.getResolutionPolicy())
            cc.view.setFrameSize(Math.min(frameSize.width, frameSize.height), Math.max(frameSize.width, frameSize.height))
        }

        cc.Canvas.instance.designResolution = cc.view.getDesignResolutionSize()
        cc.director.emit(Global.UserEvent.OrientationChanged)
    }
}

// 设置为全局，方便原生层回调
let NativeCallback = new NativeCbk()
window["NativeCallback"] = NativeCallback
export default NativeCallback